import { useEffect } from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

import { Fade } from 'components/misc/Fade'
import styles from './styles/Modal.css'

const handleClick = toggle => e => {
  const isLayout = e?.target?.dataset?.layout
  if (isLayout) toggle()
}

export const ModalLayout = ({ toggle, allowClickOut, children }) => (
  <div className={styles.layout} onClick={(toggle && allowClickOut) ? handleClick(toggle) : () => {}} data-layout>
    {children}
  </div>
)

export const Modal = ({ className, closeIconClassName, children, show, toggle, allowClickOut = true, ...rest }) => {
  useEffect(() => {
    document.body.style.height = show ? '100%' : 'auto'
    document.body.style.overflow = show ? 'hidden' : 'auto'
  }, [show])

  return (
    <Fade className={styles.fade} show={show}>
      <ModalLayout toggle={toggle} allowClickOut={allowClickOut}>
        <div className={`${styles.modal} ${className}`} {...rest}>
          {toggle && (
            <div className={styles.modalCloseWrapper} role='close' onClick={() => toggle()}>
              <i className={classNames(styles.closeIcon, closeIconClassName)} />
            </div>
          )}

          {children}
        </div>
      </ModalLayout>
    </Fade>
  )
}

Modal.propTypes = {
  toggle: PropTypes.func.isRequired,
  className: PropTypes.string,
  closeIconClassName: PropTypes.string
}

export default Modal
